export const dimensionsLabels: {
  [key: string]: string;
} = {
  length: 'Длина, м',
  width: 'Ширина, м',
  area: 'Площадь, м²',
};

export const dimensionsErrors: {
  [key: string]: {
    required: string;
    value: RegExp;
    pattern: string;
  };
} = {
  length: {
    required: 'Введите длину',
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
  width: {
    required: 'Введите ширину',
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
  area: {
    required: 'Введите площадь пола',
    value: /^\d{1,3}([,.]\d{1,2})?$/,
    pattern: 'Формат: XXX.XX',
  },
};

export const SHOULD_BE_MORE_THEN_ZERO = 'Должна быть > 0';
